export default __webpack_public_path__ + "static/media/graphic-07.15806cfa.png";